const NEWS_RELEASE = 'News Release';
const MEDIA_ADVISORY = 'Media Advisory';
const TRANSCRIPT = 'Transcript';
const PROGRAMMING_ALERT = 'Programming Alert';
const HIDDEN_RELEASE = 'Hidden Release';

export default {
    NEWS_RELEASE,
    TRANSCRIPT,
    MEDIA_ADVISORY,
    PROGRAMMING_ALERT,
    HIDDEN_RELEASE,
};
